const firebaseConfig = {
    apiKey: "AIzaSyC0aRt6Txuc-ew3KVYX5N45F6VooKu81Ec",
    authDomain: "wedding-planning-818a4.firebaseapp.com",
    projectId: "wedding-planning-818a4",
    storageBucket: "wedding-planning-818a4.appspot.com",
    messagingSenderId: "556096842135",
    appId: "1:556096842135:web:1bcb38d79576aeb50ffcd2"
  };
  export default firebaseConfig;